import { render, staticRenderFns } from "./AppVehicleInfoGeneral.vue?vue&type=template&id=55299046&scoped=true&"
import script from "./AppVehicleInfoGeneral.vue?vue&type=script&lang=js&"
export * from "./AppVehicleInfoGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AppVehicleInfoGeneral.vue?vue&type=style&index=0&id=55299046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55299046",
  null
  
)

export default component.exports